<template>
    <ClientOnly>
        <TranslateButton v-if="isTranslationActivated && educationSectionState.length > 0" section="education" />
        <template #fallback>
            <SectionActionSkeleton />
        </template>
    </ClientOnly>
</template>
<script setup lang="ts">
    import {onUnmounted} from 'vue';
    import {storeToRefs} from 'pinia';
    import {onMounted} from '#imports';
    import TranslateButton from '~/components/main/TranslateButton.vue';
    import SectionActionSkeleton from '~/components/section/SectionActionSkeleton.vue';
    import {eventBus} from '~/config/events';
    import {useEducationSectionState} from '~/features/education/composables/useEducationSectionState';
    import {TranslationDirection, useTranslationStore} from '~/store/translation/translationStore';

    const translationSection = 'educations';
    const translationField = 'content';

    // State
    const educationSectionState = useEducationSectionState();

    // Stores
    const {translateAll, replaceTranslationContent} = useTranslationStore();
    const {isTranslationActivated} = storeToRefs(useTranslationStore());

    onMounted(() => {
        eventBus.on('translation:request', translateEducations);
        eventBus.on('translation:restore', restoreEducations);
    });

    onUnmounted(() => {
        eventBus.off('translation:request', translateEducations);
        eventBus.off('translation:restore', restoreEducations);
    });

    async function translateEducations() {
        const educationContentRequests = educationSectionState.value.map((education) => {
            return {
                section: translationSection,
                field: translationField,
                index: education.id,
                originalContent: education.content ?? ' ',
            };
        });

        await translateAll(educationContentRequests);
        replaceTranslationContent(translationSection, translationField, TranslationDirection.TRANSLATE, switchTranslation);
    }

    function restoreEducations() {
        replaceTranslationContent(translationSection, translationField, TranslationDirection.RESTORE, switchTranslation);
    }

    function switchTranslation(content: string, index: number, field: string) {
        (educationSectionState.value[index] as any)[field] = content;
    }
</script>
